import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Check, CaretUpDown } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";

export default function ProductCombobox({ products, mfrMap, seriesMap, value, onChange, disabled }) {
  const [open, setOpen] = useState(false);
  const label = (p) => [mfrMap[p.manufacturer_id]?.name, seriesMap[p.series_id]?.name, p.name].filter(Boolean).join(" · ");
  const selected = products.find((p) => p.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          disabled={disabled}
          className="w-full justify-between font-normal rounded-md"
          data-testid="roll-product-combobox"
        >
          <span className="truncate">{selected ? label(selected) : "Select product…"}</span>
          <CaretUpDown size={16} className="ml-2 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0" align="start">
        <Command filter={(val, search) => (val.toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Search brand, series or colour…" data-testid="roll-product-search" />
          <CommandList>
            <CommandEmpty>No product found.</CommandEmpty>
            <CommandGroup>
              {products.map((p) => (
                <CommandItem
                  key={p.id}
                  value={`${label(p)} ${p.base_sku || ""}`}
                  onSelect={() => { onChange(p.id); setOpen(false); }}
                  data-testid={`roll-product-option-${p.id}`}
                >
                  <Check size={16} className={cn("mr-2", value === p.id ? "opacity-100" : "opacity-0")} />
                  <span className="flex items-center gap-2 truncate">
                    {p.color_hex && <span className="w-3 h-3 rounded-sm border border-slate-300 shrink-0" style={{ background: p.color_hex }} />}
                    <span className="truncate">{label(p)}</span>
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
